module.exports = __webpack_public_path__ + "img/lcd.bf803815.jpg";